import { FC, PropsWithChildren } from 'react'

import { cva } from 'class-variance-authority'

import { twMerge } from '~/lib/utils'

type CheckboxContainerProps = PropsWithChildren<
  { className?: string } & (
    | {
        columnCount?: 2 | 3
        showsGridLines?: false
      }
    // グリッド線ありの場合は2列表示しか選択できない
    | {
        columnCount?: 2
        showsGridLines: true
      }
  )
>

const checkboxContainerVariants = cva(null, {
  variants: {
    columnCount: {
      /* eslint-disable @typescript-eslint/naming-convention */
      2: null,
      3: null,
      /* eslint-enable @typescript-eslint/naming-convention */
    },
    variant: {
      default: 'gap-x-2.5',
      gridBorder: '*:h-[56px] *:py-2 *:px-4',
    },
  },
  compoundVariants: [
    {
      columnCount: 2,
      variant: 'default',
      class: '*:basis-[calc((100%-20px)/2)] *:whitespace-nowrap',
    },
    {
      columnCount: 3,
      variant: 'default',
      class: '*:basis-[calc((100%-20px)/3)]',
    },
    {
      columnCount: 2,
      variant: 'gridBorder',
      class: '*:basis-1/2 *:odd:border-r *:border-b *:border-grayBorder',
    },
  ],
})

export const CheckboxContainer: FC<CheckboxContainerProps> = ({
  columnCount = 2,
  showsGridLines = false,
  className,
  children,
}) => {
  const variant = showsGridLines ? 'gridBorder' : 'default'
  return (
    <div
      className={twMerge(
        'flex flex-wrap',
        checkboxContainerVariants({ columnCount, variant }),
        className,
      )}
    >
      {children}
    </div>
  )
}
